var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "magic-wand-examples-panel",
      style: _vm.panelStyle,
      attrs: { "aria-live": "polite", "aria-label": _vm.panelAriaLabel }
    },
    [
      _c("div", { staticClass: "magic-wand-examples-header" }, [
        _c("div", { staticClass: "magic-wand-examples-header-left" }, [
          _c("img", {
            staticClass: "magic-wand-img magic-wand-img-panel",
            attrs: {
              src: _vm.magicWandIcon,
              alt: "",
              width: "18",
              height: "18"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "magic-wand-examples-title" }, [
            _vm._v("Examples")
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "magic-wand-close-btn",
            attrs: { type: "button", "aria-label": "Close examples" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v("×")]
        )
      ]),
      _vm._v(" "),
      _vm.fieldLabel
        ? _c("p", { staticClass: "magic-wand-examples-subtitle" }, [
            _vm._v("\n    For: "),
            _c("strong", [_vm._v(_vm._s(_vm.fieldLabel))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "magic-wand-examples-hint" }, [
        _vm._v(
          "Browse examples while you write. Your text is never replaced unless you choose one."
        )
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "magic-wand-examples-loading",
              attrs: { role: "status" }
            },
            [_vm._v("Loading examples...")]
          )
        : _vm.examples.length === 0
        ? _c("div", { staticClass: "magic-wand-examples-empty" }, [
            _vm._v("\n    No examples available for this field.\n  ")
          ])
        : _c("div", { staticClass: "magic-wand-examples-single" }, [
            _c("div", { staticClass: "magic-wand-example-card" }, [
              _c(
                "p",
                {
                  staticClass: "magic-wand-example-text",
                  attrs: { "aria-live": "polite" }
                },
                [_vm._v(_vm._s(_vm.currentExample))]
              )
            ]),
            _vm._v(" "),
            _vm.confirming
              ? _c(
                  "p",
                  {
                    staticClass: "magic-wand-confirm-text",
                    attrs: { role: "alert" }
                  },
                  [_vm._v("This will replace your current text.")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "magic-wand-example-footer" }, [
              _c(
                "div",
                { staticClass: "magic-wand-example-action" },
                [
                  _vm.confirming
                    ? [
                        _c(
                          "button",
                          {
                            staticClass:
                              "magic-wand-use-btn magic-wand-confirm-yes",
                            attrs: { type: "button" },
                            on: { click: _vm.confirmUse }
                          },
                          [_vm._v("\n            Yes, use it\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "magic-wand-use-btn magic-wand-confirm-cancel",
                            attrs: { type: "button" },
                            on: { click: _vm.cancelUse }
                          },
                          [_vm._v("\n            Cancel\n          ")]
                        )
                      ]
                    : _c(
                        "button",
                        {
                          staticClass: "magic-wand-use-btn",
                          attrs: { type: "button" },
                          on: { click: _vm.requestUse }
                        },
                        [_vm._v("\n          Use this example\n        ")]
                      )
                ],
                2
              ),
              _vm._v(" "),
              _vm.examples.length > 1
                ? _c("div", { staticClass: "magic-wand-example-nav" }, [
                    _c(
                      "button",
                      {
                        staticClass: "magic-wand-nav-btn",
                        attrs: {
                          type: "button",
                          "aria-label": "Previous example",
                          disabled: _vm.currentIndex === 0
                        },
                        on: { click: _vm.prev }
                      },
                      [_vm._v("‹")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "magic-wand-nav-count" }, [
                      _vm._v(
                        _vm._s(_vm.currentIndex + 1) +
                          " / " +
                          _vm._s(_vm.examples.length)
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "magic-wand-nav-btn",
                        attrs: {
                          type: "button",
                          "aria-label": "Next example",
                          disabled: _vm.currentIndex === _vm.examples.length - 1
                        },
                        on: { click: _vm.next }
                      },
                      [_vm._v("›")]
                    )
                  ])
                : _vm._e()
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c3213c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3213c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MagicWandExamplesPanel.vue
// module id = null
// module chunks = 